export default "__VITE_ASSET__74326807__"